// generated from 94 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const attributedAdFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("attributed_ad_filter"),
  // Constants::Comparisons.matches_and_existence (AttributedAdFilter#allowed_comparisons)
  comparison_key: z.enum(["1", "2", "10", "17", "11", "12"]),
  display_name: z.string(),
  // undefined: 3 (3.19%), defined 91 (96.81%)
  // null for a blank comparison (11/12) once allow_nil_blank_filters is on: stored as nil
  // (Filter.enforce_nil_for_blank_comparison) and echoed as raw_value via Filter#get_raw_value
  raw_value: z.string().nullable().optional(),
  value: z.string().nullable(),
  varies_by_app_group: z.literal(true),
});
